/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import {
  doPost,
  doGet,
  trataMensagensErro,
  buscaDestinatarios,
  buscaEstadosSimulacaoCompensacao,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import FiltroSimulacaoCompensacao from './FiltroSimulacaoCompensacao';
import { manterApenasFiltro } from '../../utils/helpers';
import SimulacaoCompensacao from './SimulacaoCompensacao';
import User from '../../domain/User';

const TODOS_OS_RESULTADOS = 'TODOS';
const CODIGO_RGPS = '01000';

class ConsultaSimulacaoCompensacao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acao: null,
      listaRegistrosFiltrada: null,
      listaRegistrosIndexada: [],
      listaRegistrosExportacao: [],
      listaResultadosFormatados: [],
      historicoPrimeiroNivel: [],
      historicoEstadoTabelaPrimeiroNivel: [],
      historicoParametrosExportacaoPrimeiroNivel: null,
      registroVindoDoRequest: null,
      showNoContent: false,
      rowSelecionada: null,
      listaRegistrosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
      dataFormatOptions: {},
      exibirDetalhamento: false,
      colunasRetorno: this.colunasRelatorio,
      urlExportacao: null,
      parametrosExportacao: null,
      nomeRelatorio: '',
      nomeRelatorioExportacao: '',
      exibirBotaoVoltar: false,
      papelUsuarioLogado: null,
      estadosSimulacaoCompensacaoObservador: [],
      competencia: null,
      nivel: null,
      dataHistory: [],
      nomeRelatorioHistory: [],
      nomeRelatorioExportacaoHistory: [],
      colunasHistory: [],
      dataFormatHistory: [],
      estadoTabelaHistory: [],
    };
  }

  componentDidMount() {
    manterApenasFiltro('filtroSimulacaoCompensacao');
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.tratarErro);
    }
    // if (this.props.estadosSimulacaoCompensacao.length === 0) {
    //   this.recuperarEstadosSimulacaoCompensacao(this.tratarErro);
    // }
    this.definePapelFiltro();
  }

  definePapelFiltro = () => {
    let retorno = '';
    const isRgps = this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'consultar-compensacao-rgps']);
    const isRpps = this.props.auth.checkPermission(['requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'consultar-compensacao-rpps']);
    const isAnalistaSprev = this.props.auth.checkPermission(['analisar-negocio-sprev']);
    const isAnalistaDtp = this.props.auth.checkPermission(['analisar-negocio-dtpv']);
    const isAnalistaDcomp = this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);
    const isAuditorComprev = this.props.auth.checkPermission(['auditar-comprev']);

    if (isRgps) {
      retorno = 'analista-rgps';
    }
    if (isRpps) {
      retorno = 'analista-rpps';
    }
    if (isAnalistaSprev) {
      retorno = 'analista-sprev';
    }
    if (isAnalistaDtp) {
      retorno = 'analista-dtp';
    }
    if (isAnalistaDcomp) {
      retorno = 'analista-rgps';
    }
    if (isAuditorComprev) {
      retorno = 'auditor-comprev';
    }

    this.setState({
      papelUsuarioLogado: retorno,
    }, () => this.recuperarEstadosSimulacaoCompensacao(this.tratarErro));
  }

  handleErrorBuscaPeloCnpjLogado = () => (
    ''
  );

  recuperarEstadosSimulacaoCompensacao = (callback) => {
    if (this.props.estadosSimulacaoCompensacao.length === 0) {
      if (this.state.papelUsuarioLogado === 'analista-rpps') {
        const usuarioLogado = new User(localStorage.getItem('jwt'));
        const cnpj = usuarioLogado.cnpjDoPapel();
        if (cnpj) {
          doGet(
            `participantes-compensacao/${cnpj}`,
            this.handleSuccessBuscaPeloCnpjLogado,
            callback,
          );
        }
      } else if (this.state.papelUsuarioLogado === 'analista-rgps') {
        buscaEstadosSimulacaoCompensacao(this.tratarErro, CODIGO_RGPS);
      }
    }
  }

  recuperarCnpjParticipanteComoObservador = (codigo) => {
    if (codigo) {
      buscaEstadosSimulacaoCompensacao(this.tratarErro, codigo);
    }
  }

  handleSuccessBuscaPeloCnpjLogado = (response) => {
    if (response.data) {
      buscaEstadosSimulacaoCompensacao(this.tratarErro, response.data.codigo);
    }
  }

  extrairValoresParaPesquisar = (exportacao) => {
    const { filtrosConsulta } = { ...this.state };
    const retorno = [];
    let valor;
    if ((filtrosConsulta.lista && filtrosConsulta.lista.length > 0)) {
      filtrosConsulta.lista.forEach((item) => {
        if (exportacao) {
          if (item.value && item.label) {
            valor = item.label.concat(' - ', item.value);
            retorno.push(valor);
          }
        } else {
          // if (item.value) {
          valor = Number(item.value);
          retorno.push(valor);
          // }
        }
      });
    }
    return retorno;
  }

  preparaNovaConsulta = (filtrosPesquisa) => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };

    let { filtrosConsulta } = { ...this.state };
    let filtro = {};

    if (filtrosPesquisa) {
      filtro = filtrosPesquisa;
    } else {
      filtro = filtrosConsulta;
    }

    filtrosConsulta = this.montaFiltros(filtro);
    this.setState({
      ...this.state,
      filtrosConsulta,
      estadoTabela,
      listaRequerimentosFiltrada: null,
      nivel: 1,
    }, this.executaConsulta);
  }

  preparaNovaConsultaListaRequerimentos = (row) => {
    let { historicoEstadoTabelaPrimeiroNivel } = { ...this.state };
    const { estadoTabela } = { ...this.state };

    historicoEstadoTabelaPrimeiroNivel = estadoTabela;

    const novoEstadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 5,
      paginaAtual: 1,
    };

    let filtrosConsulta = {};
    if (row) {
      filtrosConsulta = this.montaFiltrosListaRequerimentos(row);
    } else {
      filtrosConsulta = this.montaFiltrosListaRequerimentos(this.state.filtrosConsulta);
    }

    this.setState({
      ...this.state, filtrosConsulta, estadoTabela: novoEstadoTabela, historicoEstadoTabelaPrimeiroNivel,
    }, this.executaConsultaListaRequerimentos);
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      let urlRelatorio = 'relatorios/simulacao-calculo';
      const listaEstados = this.extrairValoresParaPesquisar(false);
      const parametros = {
        visaoSimulacaoCompensacao: this.state.filtrosConsulta.visaoSimulacaoCompensacao,
        'start-position': primeiroItem,
        'max-results': resultadosPorPagina,
      };
      let callback = this.tratarSucesso();

      if (this.state.filtrosConsulta.participante) {
        parametros.participante = this.state.filtrosConsulta.participante;
      }

      if (this.state.filtrosConsulta.participanteObservador) {
        parametros.participanteObservador = this.state.filtrosConsulta.participanteObservador;
      }

      if (listaEstados !== null && listaEstados.length > 0) {
        parametros.estados = listaEstados;
      }

      // checkbox marcado
      if (this.state.filtrosConsulta.pesquisarRequerimentosNaoAptos) {
        parametros.pesquisarRequerimentosNaoAptos = this.state.filtrosConsulta.pesquisarRequerimentosNaoAptos;
        urlRelatorio = `${urlRelatorio}/lista-requerimentos-nao-aptos`;
        callback = this.tratarSucessoNaoAptos();
      }

      this.setState({
        urlExportacao: urlRelatorio,
        parametrosExportacao: parametros,
        historicoParametrosExportacaoPrimeiroNivel: parametros,
      }, () => this.preparaRequest(urlRelatorio, parametros, callback));
    }
  }

  preparaRequest = (urlRelatorio, parametros, callback) => {
    doPost(
      urlRelatorio,
      parametros,
      callback,
      this.tratarErro,
    );
  }

  // filtro escolhido na tela
  realizaConsulta = (filtrosPesquisa) => {
    this.preparaNovaConsulta(filtrosPesquisa);
  }

  realizaConsultaAlterarPagina = (filtrosPesquisa) => {
    let { filtrosConsulta } = { ...this.state };
    let filtro = {};

    if (filtrosPesquisa) {
      filtro = filtrosPesquisa;
    } else {
      filtro = filtrosConsulta;
    }

    filtrosConsulta = this.montaFiltros(filtro);
    this.setState({ ...this.state, filtrosConsulta }, this.executaConsulta);
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = [];
    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;

    if (atributosPesquisa.participanteObservador) {
      atributos = { ...atributos, participanteObservador: atributosPesquisa.participanteObservador };
    }
    if (atributosPesquisa.visaoSimulacaoCompensacao) {
      atributos = {
        ...atributos,
        visaoSimulacaoCompensacao: atributosPesquisa.visaoSimulacaoCompensacao,
      };
    }
    if (atributosPesquisa.tipoEntidade) {
      if (atributosPesquisa.tipoEntidade === '01000') {
        atributos = { ...atributos, participante: '01000' };
      }
    }
    if (atributosPesquisa['destinatario-rpps']) {
      atributos = { ...atributos, participante: atributosPesquisa['destinatario-rpps'] };
    } else if (atributosPesquisa.participante) {
      atributos = { ...atributos, participante: atributosPesquisa.participante };
    }

    if (atributosPesquisa.lista && atributosPesquisa.lista.length > 0) {
      atributos = { ...atributos, lista: atributosPesquisa.lista };
    }
    if (atributosPesquisa.superintendencia) {
      atributos = { ...atributos, superintendencia: atributosPesquisa.superintendencia };
    }
    if (atributosPesquisa.gex) {
      atributos = { ...atributos, gex: atributosPesquisa.gex };
    }
    if (atributosPesquisa.aps) {
      atributos = { ...atributos, aps: atributosPesquisa.aps };
    }
    if (atributosPesquisa.pesquisarRequerimentosNaoAptos) {
      atributos = { ...atributos, pesquisarRequerimentosNaoAptos: atributosPesquisa.pesquisarRequerimentosNaoAptos };
    }

    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  trataErrosResponse = (error) => {
    if (error && error.data) {
      trataMensagensErro(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);
    }
  }

  prepararColunasExportacao = (data, colunas) => {
    const dados = data.map((item) => {
      const linha = Object.assign({}, item);
      colunas.forEach((c) => {
        const key = Object.keys(item)[c.index];
        const coluna = item[key];
        const colunaFormatada = this.formatarColuna(coluna, c.tipo);
        linha[key] = colunaFormatada;
      });
      return linha;
    });
    return dados;
  }

  montarColunasCabecalho = () => {
    const tableHeader = this.colunasRelatorio.slice();
    return tableHeader;
  }

  pesquisarColunaJson = (json, coluna) => {
    let retorno = json[coluna];
    if (retorno === undefined) {
      retorno = '';
    }
    return retorno;
  }

  colunasRelatorio = [
    'Solicitante',
    'Destinatário',
    'Valor Estoque',
    'Valor Fluxo Acumulado',
    'Valor Fluxo',
    'Valor Total',
  ];

  colunasRelatorioRequerimentosNaoAptos = [
    'Solicitante',
    'Destinatário',
    'Protocolo',
    'Cpf',
    'Tipo requerimento',
    'Motivo',
    'Estado',
  ];

  colunasSimulacaoRequerimentos = [
    'Nome beneficiário',
    'Protocolo',
    'Solicitante',
    'Destinatário',
    'CPF',
    'Matrícula',
    'Estado',
    'Tipo requerimento',
    'Tipo aposentadoria',
    'Número benefício',
    'Regra de cálculo',
    'Valor pro rata mensal',
    'Valor estoque',
    'Valor 13º estoque',
    'Valor total estoque',
    'Valor fluxo',
    'Valor 13º fluxo',
    'Valor total fluxo',
    'Valor fluxo acumulado',
    'Valor 13º fluxo acumulado',
    'Valor total fluxo acumulado',
    'Valor total requerimento',
    'Data inicio fluxo acumulado',
    'Data fim fluxo acumulado',
    'Data inicio estoque',
    'Data fim estoque',
  ];

  addTipoEstadoLabel = tipo => (
    listUtils.getObject(listUtils.tiposEstado, tipo).label
  )

  addTipoProRataInicialLabel = (tipo) => {
    let retorno = '';
    if (tipo && tipo !== null) {
      retorno = listUtils.getObject(listUtils.tiposProRataInicial, tipo).label;
    }
    return retorno;
  };

  extrairColunasJsonNaoApto = (data) => {
    let objetoLinha = {};
    const dados = data.map((item) => {
      const objDestinatario = `${item[Object.keys(item)[5]]}-${item[Object.keys(item)[4]]}`;
      const objSolicitante = `${item[Object.keys(item)[3]]}-${item[Object.keys(item)[2]]}`;
      objetoLinha = {
        solicitante: objSolicitante,
        destinatario: objDestinatario,
        protocolo: this.pesquisarColunaJson(item, 'idProtocolo'),
        cpf: this.pesquisarColunaJson(item, 'idCpf'),
        tipoRequerimento: this.pesquisarColunaJson(item, 'tipoRequerimento'),
        motivoNaoAptidao: this.pesquisarColunaJson(item, 'motivoNaoAptidao'),
        estado: this.addTipoEstadoLabel(this.pesquisarColunaJson(item, 'estado')),
      };
      return objetoLinha;
    });
    return dados;
  }

  extrairColunasJson = (data) => {
    let objetoLinha = {};
    const dados = data.map((item) => {
      const objDestinatario = `${item[Object.keys(item)[1]]}-${item[Object.keys(item)[0]]}`;
      const objSolicitante = `${item[Object.keys(item)[3]]}-${item[Object.keys(item)[2]]}`;
      objetoLinha = {
        solicitante: objSolicitante,
        destinatario: objDestinatario,
        valorEstoque: this.pesquisarColunaJson(item, 'valorEstoque'),
        valorFluxoAcumulado: this.pesquisarColunaJson(item, 'valorFluxoAcumulado'),
        valorFluxo: this.pesquisarColunaJson(item, 'valorFluxo'),
        valorTotal: this.pesquisarColunaJson(item, 'valorTotal'),
        visaoSimulacaoCompensacao: this.state.filtrosConsulta.visaoSimulacaoCompensacao,
      };
      return objetoLinha;
    });
    return dados;
  }

  extrairColunasListaRequerimentosJson = (data) => {
    let objetoLinha = {};
    const dados = data.map((item) => {
      objetoLinha = {
        nomeBeneficiario: this.pesquisarColunaJson(item, 'nomeBeneficiario'),
        idProtocolo: this.pesquisarColunaJson(item, 'idProtocolo'),
        solicitante: `${this.pesquisarColunaJson(item, 'nomeSolicitante')} - ${this.pesquisarColunaJson(item, 'idSolicitante')}`,
        destinatario: `${this.pesquisarColunaJson(item, 'nomeDestinatario')} - ${this.pesquisarColunaJson(item, 'idDestinatario')}`,
        idCpf: this.pesquisarColunaJson(item, 'idCpf'),
        matricula: this.pesquisarColunaJson(item, 'matricula'),
        estado: this.addTipoEstadoLabel(this.pesquisarColunaJson(item, 'estado')),
        tipoRequerimento: this.pesquisarColunaJson(item, 'tipoRequerimento'),
        tipoAposentadoria: this.pesquisarColunaJson(item, 'tipoAposentadoria'),
        numeroBeneficio: this.pesquisarColunaJson(item, 'numeroBeneficio'),
        tipoProRataInicial: this.addTipoProRataInicialLabel(this.pesquisarColunaJson(item, 'tipoProRataInicial')),
        valorProRataMensal: this.pesquisarColunaJson(item, 'valorProRataMensal'),
        valorEstoque: this.pesquisarColunaJson(item, 'valorEstoque'),
        valor13Estoque: this.pesquisarColunaJson(item, 'valor13Estoque'),
        valorTotalEstoque: this.pesquisarColunaJson(item, 'valorTotalEstoque'),
        valorFluxo: this.pesquisarColunaJson(item, 'valorFluxo'),
        valor13Fluxo: this.pesquisarColunaJson(item, 'valor13Fluxo'),
        valorTotalFluxo: this.pesquisarColunaJson(item, 'valorTotalFluxo'),
        valorFluxoAcumulado: this.pesquisarColunaJson(item, 'valorFluxoAcumulado'),
        valor13FluxoAcumuladorFluxo: this.pesquisarColunaJson(item, 'valor13FluxoAcumuladorFluxo'),
        valorTotalFluxoAcumulado: this.pesquisarColunaJson(item, 'valorTotalFluxoAcumulado'),
        valorTotalRequerimento: this.pesquisarColunaJson(item, 'valorTotalRequerimento'),
        dataInicioFluxoAcumulado: this.pesquisarColunaJson(item, 'dataInicioFluxoAcumulado'),
        dataFimFluxoAcumulado: this.pesquisarColunaJson(item, 'dataFimFluxoAcumulado'),
        dataInicioEstoque: this.pesquisarColunaJson(item, 'dataInicioEstoque'),
        dataFimEstoque: this.pesquisarColunaJson(item, 'dataFimEstoque'),
      };
      return objetoLinha;
    });
    return dados;
  }

  tratarSucesso = () => (response) => {
    let quantidadeTotalResultados = 0;
    let colunasFormatarExportacao = [];
    let dataFormatOptions = {};
    const { estadoTabela } = { ...this.state };

    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;

    const estadoTabelaPrimeiroNivel = {
      quantidadeTotalResultados: estadoTabela.quantidadeTotalResultados,
      resultadosPorPagina: estadoTabela.resultadosPorPagina,
      paginaAtual: estadoTabela.paginaAtual,
    };

    if (response.data !== '') {
      const lista = this.extrairColunasJson(response.data.simulacoes);
      dataFormatOptions = this.relatorioDataFormatOptions;
      colunasFormatarExportacao = this.listaColunasFormatar;
      const dadosFormatados = this.prepararColunasExportacao(lista, colunasFormatarExportacao);
      const competencia = this.formatarCompetencia(response.data.mes, response.data.ano);

      this.setState({
        listaResultados: lista,
        listaResultadosFormatados: dadosFormatados,
        dataFormatOptions,
        estadoTabela,
        colunasRetorno: this.colunasRelatorio,
        dataHistory: [...this.state.dataHistory, dadosFormatados],
        colunasHistory: [...this.state.colunasHistory, this.colunasRelatorio],
        dataFormatHistory: [...this.state.dataFormatHistory, dataFormatOptions],
        estadoTabelaHistory: [...this.state.estadoTabelaHistory, estadoTabelaPrimeiroNivel],
        competencia,
      }, this.montarTitulo(response.data.totalizador, competencia, dadosFormatados, response.data.nivel));
    } else {
      this.setState({
        colunasRetorno: this.colunasRelatorio,
        listaResultados: [],
        listaResultadosFormatados: [],
        estadoTabela,
        dataFormatOptions: {},
        dataHistory: [],
        colunasHistory: [],
        dataFormatHistory: [],
        exibirBotaoVoltar: false,
      }, this.montarTitulo('', '', [], ''));
    }
  };

  tratarSucessoNaoAptos = () => (response) => {
    let quantidadeTotalResultados = 0;
    const { estadoTabela } = { ...this.state };
    let colunasFormatarExportacao = [];
    const dataFormatOptions = {};

    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;

    if (response.data !== '') {
      const lista = this.extrairColunasJsonNaoApto(response.data);
      colunasFormatarExportacao = this.listaColunasFormatarRequerimentosNaoAptos;
      const dadosFormatados = this.prepararColunasExportacao(lista, colunasFormatarExportacao);

      this.setState({
        listaResultadosFormatados: dadosFormatados,
        estadoTabela,
        colunasRetorno: this.colunasRelatorioRequerimentosNaoAptos,
        dataFormatOptions,
      }, this.montarTituloNaoAptos(lista));
    } else {
      this.setState({
        listaResultadosFormatados: [],
        estadoTabela,
        colunasRetorno: this.colunasRelatorioRequerimentosNaoAptos,
      }, this.montarTitulo([]));
    }
  }

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPagamentos)
   */
  tratarFiltroNaLista = (listaRegistrosFiltrada) => {
    this.setState({ listaRegistrosFiltrada, listaRegistrosIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      let lista;
      if (error.status) {
        if (error.data.erros) {
          if (error.data.erros[0]) {
            const codigoErro = error.data.erros[0].codigo;
            if (codigoErro === 1587) {
              lista = [];
            }
          }
        }
        this.setState({
          noContentPrimaryMessage: `${data.mensagem}`,
          noContentSecondaryMessage: `${data.descricao}`,
          listaRegistrosIndexada: lista,
        });
      } else {
        this.setState({
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  formatarValorLabel = (valorCompensacao) => {
    let valorFormatado = '';
    if (valorCompensacao) {
      valorFormatado = valorCompensacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
    }
    return valorFormatado;
  };

  showDetalhe = (row) => {
    this.props.history.push(`/simulacaocompensacao/detalhe/${row.idSimulacaoCompensacao}`);
  }

  // FORMATA COLUNAS PARA EXPORTACAO DA PLANILHA
  formatarColuna = (cell, tipo) => {
    let valor = cell;
    const cellDataPreenchida = (cell !== null && cell !== '' && cell !== undefined);

    if (tipo === 'numero') {
      valor = new Intl.NumberFormat('pt-BR').format(cell);
    } else if (tipo === 'moeda') {
      valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).formatToParts(cell).map(({ type, value }) => {
        switch (type) {
          case 'currency': return '';
          default: return value;
        }
      }).reduce((string, part) => string + part);
    } else if (tipo === 'cpf') {
      valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (tipo === 'cnpj') {
      valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    } else if (tipo === 'nit') {
      if (Number.isInteger(cell)) {
        valor = cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
      } else {
        valor = cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
      }
    } else if (tipo === 'protocolo') {
      valor = `'${cell}`;
    } else if (tipo === 'data') {
      if (cellDataPreenchida) {
        valor = moment(cell).format('DD/MM/YYYY');
      }
    }
    return valor.trim();
  }

  montaLink = () => (cell, row) => (
    <React.Fragment>
      <a href="#" onClick={() => this.preparaNovaConsultaListaRequerimentos(row)}>{cell}</a>
    </React.Fragment>
  )

  montaColuna = tipo => (cell) => {
    let valor = cell;
    const cellDataPreenchida = (cell !== null && cell !== '' && cell !== undefined);
    if (tipo === 'numero') {
      valor = new Intl.NumberFormat('pt-BR').format(cell);
    } else if (tipo === 'moeda') {
      valor = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).formatToParts(cell).map(({ type, value }) => {
        switch (type) {
          case 'currency': return '';
          default: return value;
        }
      }).reduce((string, part) => string + part);
    } else if (tipo === 'cpf') {
      valor = cell.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    } else if (tipo === 'cnpj') {
      valor = cell.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
    } else if (tipo === 'nit') {
      if (Number.isInteger(cell)) {
        valor = cell.toString().replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
      } else {
        valor = cell.replace(/(\d{1})(\d{3})(\d{3})(\d{3})(\d{1})/g, '$1.$2.$3.$4-$5');
      }
    } else if (tipo === 'data') {
      if (cellDataPreenchida) {
        valor = moment(cell).format('DD/MM/YYYY');
      }
    }

    return (
      <React.Fragment>
        {valor.trim()}
      </React.Fragment>
    );
  }

  relatorioDataFormatNaoAptosOptions = {
    3: this.formatarColuna('cpf'),
  }

  relatorioDataFormatOptions = {
    0: this.montaLink('solicitante'),
    1: this.montaLink('destinatario'),
  }

  listaRequerimentosDataFormatOptions = {
    4: this.formatarColuna('cpf'),
    11: this.formatarColuna('moeda'),
    12: this.formatarColuna('moeda'),
    13: this.formatarColuna('moeda'),
    14: this.formatarColuna('moeda'),
    15: this.formatarColuna('moeda'),
    16: this.formatarColuna('moeda'),
    17: this.formatarColuna('moeda'),
    18: this.formatarColuna('moeda'),
    19: this.formatarColuna('moeda'),
    20: this.formatarColuna('moeda'),
    21: this.formatarColuna('moeda'),
    22: this.formatarColuna('data'),
    23: this.formatarColuna('data'),
    24: this.formatarColuna('data'),
    25: this.formatarColuna('data'),
  }

  listaColunasFormatar = [
    { index: 2, tipo: 'moeda' },
    { index: 3, tipo: 'moeda' },
    { index: 4, tipo: 'moeda' },
    { index: 5, tipo: 'moeda' },
  ];

  listaColunasRequerimentoFormatar = [
    { index: 4, tipo: 'cpf' },
    { index: 11, tipo: 'moeda' },
    { index: 12, tipo: 'moeda' },
    { index: 13, tipo: 'moeda' },
    { index: 14, tipo: 'moeda' },
    { index: 15, tipo: 'moeda' },
    { index: 16, tipo: 'moeda' },
    { index: 17, tipo: 'moeda' },
    { index: 18, tipo: 'moeda' },
    { index: 19, tipo: 'moeda' },
    { index: 20, tipo: 'moeda' },
    { index: 21, tipo: 'moeda' },
    { index: 22, tipo: 'data' },
    { index: 23, tipo: 'data' },
    { index: 24, tipo: 'data' },
    { index: 25, tipo: 'data' },
  ];

  listaColunasFormatarRequerimentosNaoAptos = [
    { index: 3, tipo: 'cpf' },
  ];

  defineContainerStyle = () => {
    let width = this.state.colunasRetorno.length * 130;
    if (width < 1140) {
      width = 1140;
    }
    return { width: `${width}px` };
  };

  addTipoRequerimentoLabel = tipo => (
    listUtils.getObject(listUtils.tipoRequerimento, tipo).label
  )

  addTipoAposentadoriaLabel = (tipo) => {
    const analistaRGPSLogado = User.logged().isRGPS();
    let lista = null;
    if (analistaRGPSLogado) {
      lista = listUtils.tipoAposentadoriaRGPS;
    } else {
      lista = listUtils.tipoAposentadoriaRPPS;
    }
    return listUtils.getObject(lista, tipo).label;
  }

  formatarLista = (lista) => {
    const retorno = [];
    if (lista) {
      lista.forEach((item) => {
        const aux = item;
        aux.tipoRequerimento = this.addTipoRequerimentoLabel(item.tipoRequerimento);
        aux.tipoAposentadoria = this.addTipoAposentadoriaLabel(item.tipoAposentadoria);
        retorno.push(aux);
      });
    }
    return retorno;
  }
  // Lista de requerimentos trazida quando o link do destinatario ou do solicitante é clicado
  tratarSucessoListaRequerimentos = () => (response) => {
    let quantidadeTotalResultados = 0;
    let colunasFormatarExportacao = [];
    const dataFormatOptions = {};
    const { estadoTabela } = { ...this.state };
    const { estadoTabelaHistory } = { ...this.state };

    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;

    let estadoTabelaHistorico = null;

    if (estadoTabelaHistory.length > 0) {
      estadoTabelaHistorico = {
        quantidadeTotalResultados: estadoTabelaHistory[0].quantidadeTotalResultados,
        resultadosPorPagina: estadoTabelaHistory[0].resultadosPorPagina,
        paginaAtual: estadoTabela.paginaAtual,
      };
      this.setState({
        estadoTabelaHistory: [...this.state.estadoTabelaHistory, estadoTabelaHistorico],
      });
    }
    if (response.data !== '') {
      const lista = this.extrairColunasListaRequerimentosJson(response.data.requerimentos);
      colunasFormatarExportacao = this.listaColunasRequerimentoFormatar;
      const dadosFormatados = this.prepararColunasExportacao(lista, colunasFormatarExportacao);

      this.setState({
        listaResultados: lista,
        listaResultadosFormatados: dadosFormatados,
        dataFormatOptions,
        colunasRetorno: this.colunasSimulacaoRequerimentos,
        estadoTabela,
        colunasHistory: [...this.state.colunasHistory, this.state.colunasRetorno],
        exibirBotaoVoltar: true,
        nivel: response.data.nivel,
      }, this.montarTituloListaRequerimentos(lista));
    } else {
      this.setState({
        colunasRetorno: this.colunasSimulacaoRequerimentos,
        listaResultados: [],
        listaResultadosFormatados: [],
        estadoTabela,
        exibirBotaoVoltar: true,
      }, this.montarTitulo('', '', [], ''));
    }
  };

  extrairCodigoParticipante = (participante) => {
    let retorno = participante;
    if (participante.indexOf('-') !== -1) {
      const split = participante.split('-')[1];
      retorno = split;
    }
    return retorno;
  };

  montaFiltrosListaRequerimentos = (atributosPesquisa) => {
    let atributos = [];
    const { filtrosConsulta } = { ...this.state };
    const { nivel } = { ...this.state };

    if (atributosPesquisa.visaoSimulacaoCompensacao) {
      atributos = {
        ...atributos,
        visaoSimulacaoCompensacao: atributosPesquisa.visaoSimulacaoCompensacao,
      };
    }

    let atributoParticipante = '';
    if (atributosPesquisa.visaoSimulacaoCompensacao && atributosPesquisa.visaoSimulacaoCompensacao === 1) {
      atributoParticipante = atributosPesquisa.destinatario ? atributosPesquisa.destinatario : '';
    } else {
      atributoParticipante = atributosPesquisa.solicitante ? atributosPesquisa.solicitante : '';
    }

    if (nivel !== null && nivel === 2) {
      atributoParticipante = atributosPesquisa.participante;
      atributos = { ...atributos, participante: atributoParticipante };
    } else {
      atributos = { ...atributos, participante: this.extrairCodigoParticipante(atributoParticipante) };
    }

    if (filtrosConsulta.participanteObservador) {
      atributos = { ...atributos, participanteObservador: filtrosConsulta.participanteObservador };
    }

    if (filtrosConsulta.lista && filtrosConsulta.lista.length > 0) {
      atributos = { ...atributos, lista: filtrosConsulta.lista };
    }

    // if (atributosPesquisa.solicitante) {
    //   atributos = { ...atributos, solicitante: this.extrairCodigoParticipante(atributosPesquisa.solicitante) };
    // }
    // if (atributosPesquisa.destinatario) {
    //   atributos = { ...atributos, participante: this.extrairCodigoParticipante(atributosPesquisa.destinatario) };
    // }

    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    let primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;

    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }
    if (nivel === null || nivel === 1) {
      primeiroItem = 0;
    }
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  realizaConsultaListaRequerimentos = (row) => {
    this.preparaNovaConsultaListaRequerimentos(row);
  }

  realizaConsultaListaRequerimentosAlterarPagina = (row) => {
    let filtrosConsulta = {};
    if (row) {
      filtrosConsulta = this.montaFiltrosListaRequerimentos(row);
    } else {
      filtrosConsulta = this.montaFiltrosListaRequerimentos(this.state.filtrosConsulta);
    }

    this.setState({ ...this.state, filtrosConsulta }, this.executaConsultaListaRequerimentos);
  }

  executaConsultaListaRequerimentos = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      let primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      const { nivel } = { ...this.state };
      const urlRelatorio = 'relatorios/simulacao-calculo/lista-requerimentos';
      const listaEstados = this.extrairValoresParaPesquisar(false);

      if (nivel === null || nivel === 1) {
        primeiroItem = 0;
      }

      const parametros = {
        visaoSimulacaoCompensacao: this.state.filtrosConsulta.visaoSimulacaoCompensacao,
        // participante: this.state.filtrosConsulta.participante,
        'start-position': primeiroItem,
        'max-results': resultadosPorPagina,
      };

      if (this.state.filtrosConsulta.participante) {
        parametros.participante = this.state.filtrosConsulta.participante;
      }

      if (this.state.filtrosConsulta.participanteObservador) {
        parametros.participanteObservador = this.state.filtrosConsulta.participanteObservador;
      }

      if (listaEstados !== null && listaEstados.length > 0) {
        parametros.estados = listaEstados;
      }

      this.setState({
        urlExportacao: urlRelatorio,
        parametrosExportacao: parametros,
      }, () => this.preparaRequest(urlRelatorio, parametros, this.tratarSucessoListaRequerimentos()));
    } else {
      this.setState({ listaRegistrosIndexada: [], listaRegistrosIndexadaAtualizada: true });
    }
  }

  defineListaParaTabela = () => {
    if (this.state.listaRegistrosFiltrada !== null) {
      return this.state.listaRegistrosFiltrada;
    }
    return this.state.listaRegistrosIndexada;
  }

  alterarPagina = (pagina, quantidadeResultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    const { nivel } = { ...this.state };
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (quantidadeResultadosPorPagina) {
      estadoTabela.resultadosPorPagina = quantidadeResultadosPorPagina;
    }

    let callback = this.realizaConsultaAlterarPagina;
    if (nivel !== null && nivel === 2) {
      callback = this.realizaConsultaListaRequerimentosAlterarPagina;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, callback);
  }

  // alterarResultadosPorPagina = (resultadosPorPagina) => {
  //   const { estadoTabela } = { ...this.state };
  //   estadoTabela.resultadosPorPagina = resultadosPorPagina;
  //   this.setState({
  //     estadoTabela,
  //     ...this.state,
  //   }, this.realizaConsulta());
  // }

  exibirComplementoEstadosSelecionados = (lista, exportacao) => {
    const listaPreenchida = (lista.length > 0);
    let retorno = '';
    retorno = `com os estados: [ ${listaPreenchida ? this.extrairValoresParaPesquisar(exportacao) : TODOS_OS_RESULTADOS} ]`;
    return retorno.toUpperCase();
  };

  montarTituloListaRequerimentos = (listaRetorno) => {
    let nomeSolicitante = '';
    let nomeDestinatario = '';

    if (listaRetorno && listaRetorno.length > 0) {
      nomeSolicitante = listaRetorno[0].solicitante;
      nomeDestinatario = listaRetorno[0].destinatario;
    }
    const titulo = ` - Lista de requerimentos para o solicitante ${nomeSolicitante} e o destinatário ${nomeDestinatario}`;
    this.setState({
      nomeRelatorio: `Simulação de Compensação${titulo}`,
      nomeRelatorioExportacao: `Simulação de Compensação${titulo}`,
    });
  }

  montarTituloNaoAptos = (listaRetorno) => {
    let retornoTituloSemDescricaoEstado = '';
    let retornoTituloComDescricaoEstado = '';
    let complementoEstadosSemDescricao = '';
    let complementoEstadosComDescricao = '';
    const { filtrosConsulta } = { ...this.state };
    const titulo = ' - Requerimentos que não foram aptos para realizar a simulação';
    retornoTituloSemDescricaoEstado = titulo;
    retornoTituloComDescricaoEstado = titulo;

    if (filtrosConsulta.lista && filtrosConsulta.lista.length > 0) {
      complementoEstadosSemDescricao = `${this.exibirComplementoEstadosSelecionados(filtrosConsulta.lista, false)}`;
      complementoEstadosComDescricao = `${this.exibirComplementoEstadosSelecionados(filtrosConsulta.lista, true)}`;
    }
    if (listaRetorno && listaRetorno.length > 0) {
      retornoTituloComDescricaoEstado = retornoTituloSemDescricaoEstado;
      if (complementoEstadosSemDescricao !== '') {
        retornoTituloSemDescricaoEstado = `${retornoTituloSemDescricaoEstado} ${complementoEstadosSemDescricao}`;
      }
      if (complementoEstadosComDescricao !== '') {
        retornoTituloComDescricaoEstado = `${retornoTituloComDescricaoEstado} ${complementoEstadosComDescricao}`;
      }
    }
    this.setState({
      nomeRelatorio: `Simulação de Compensação${retornoTituloSemDescricaoEstado}`,
      nomeRelatorioExportacao: `Simulação de Compensação${retornoTituloComDescricaoEstado}`,
    });
  }

  montarTitulo = (totalizador, competencia, listaRetorno, nivel) => {
    let retornoTituloSemDescricaoEstado = '';
    let retornoTituloComDescricaoEstado = '';
    let paramComplementoTitulo = '';
    let complementoEstadosSemDescricao = '';
    let complementoEstadosComDescricao = '';
    const { complementoTitulo } = { ...this.props };
    const { filtrosConsulta } = { ...this.state };

    if (complementoTitulo !== null) {
      paramComplementoTitulo = JSON.parse(complementoTitulo);
      if (paramComplementoTitulo.complementoTitulo && paramComplementoTitulo.complementoTitulo !== '') {
        retornoTituloSemDescricaoEstado = ` - ${paramComplementoTitulo.complementoTitulo}`;
        retornoTituloComDescricaoEstado = ` - ${paramComplementoTitulo.complementoTitulo}`;
      }
    }

    if (filtrosConsulta.lista && filtrosConsulta.lista.length > 0) {
      complementoEstadosSemDescricao = `${this.exibirComplementoEstadosSelecionados(filtrosConsulta.lista, false)}`;
      complementoEstadosComDescricao = `${this.exibirComplementoEstadosSelecionados(filtrosConsulta.lista, true)}`;
    }

    if (listaRetorno && listaRetorno.length > 0) {
      retornoTituloSemDescricaoEstado = `${retornoTituloSemDescricaoEstado} é de R$ ${totalizador.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 })}`;
      retornoTituloSemDescricaoEstado = `${retornoTituloSemDescricaoEstado} na competência ${competencia !== null ? competencia : this.state.competencia}`;
      retornoTituloComDescricaoEstado = retornoTituloSemDescricaoEstado;
      if (complementoEstadosSemDescricao !== '') {
        retornoTituloSemDescricaoEstado = `${retornoTituloSemDescricaoEstado} ${complementoEstadosSemDescricao}`;
      }
      if (complementoEstadosComDescricao !== '') {
        retornoTituloComDescricaoEstado = `${retornoTituloComDescricaoEstado} ${complementoEstadosComDescricao}`;
      }
    }

    if (nivel === 1) {
      this.setState({
        nomeRelatorioHistory: [...this.state.nomeRelatorioHistory, `Simulação de Compensação${retornoTituloSemDescricaoEstado}`],
        nomeRelatorioExportacaoHistory: [...this.state.nomeRelatorioExportacaoHistory, `Simulação de Compensação${retornoTituloSemDescricaoEstado}`],
      });
    }

    this.setState({
      nomeRelatorio: `Simulação de Compensação${retornoTituloSemDescricaoEstado}`,
      nomeRelatorioExportacao: `Simulação de Compensação${retornoTituloComDescricaoEstado}`,
    });
  };

  formatarCompetencia = (mes, ano) => {
    let objCompetencia = `${null}/${null}`;
    if (mes !== '0' && ano !== '0') {
      objCompetencia = `${mes}/${ano}`;
      if (objCompetencia.length !== 7) {
        objCompetencia = `0${objCompetencia}`;
      }
    }
    return objCompetencia;
  };

  handleVoltar = () => {
    const {
      historicoPrimeiroNivel,
      historicoEstadoTabelaPrimeiroNivel,
      historicoParametrosExportacaoPrimeiroNivel,
    } = { ...this.state };

    const { nivel } = { ...this.state };
    const historicoDados = this.state.dataHistory.pop();
    const historicoColunas = this.state.colunasHistory.pop();
    const historicoNomeRelatorio = this.state.nomeRelatorioHistory.pop();
    const historicoNomeRelatorioExportacao = this.state.nomeRelatorioExportacaoHistory.pop();
    const historicoDataFormatOptions = this.relatorioDataFormatOptions;
    const historicoEstadoTabela = this.state.estadoTabelaHistory.pop();

    if (historicoPrimeiroNivel && historicoPrimeiroNivel.length === 0) {
      this.setState({
        historicoPrimeiroNivel: historicoDados,
      });
    }
    let estadoTabelaAtual = historicoEstadoTabela;
    if (historicoEstadoTabelaPrimeiroNivel && historicoEstadoTabelaPrimeiroNivel.length === 0) {
      this.setState({
        historicoEstadoTabelaPrimeiroNivel: historicoEstadoTabela,
      });
    } else if (historicoEstadoTabelaPrimeiroNivel && historicoEstadoTabelaPrimeiroNivel.length !== 0) {
      estadoTabelaAtual = historicoEstadoTabelaPrimeiroNivel;
      this.setState({
        historicoEstadoTabelaPrimeiroNivel: historicoEstadoTabela,
      });
    }

    this.setState({
      urlExportacao: 'relatorios/simulacao-calculo',
      parametrosExportacao: historicoParametrosExportacaoPrimeiroNivel,
      listaResultadosFormatados: historicoDados && historicoDados.length === 0 ? historicoPrimeiroNivel : historicoDados,
      colunasRetorno: (historicoColunas === undefined || nivel === 2) ? this.colunasRelatorio : historicoColunas,
      nomeRelatorio: historicoNomeRelatorio,
      nomeRelatorioExportacao: historicoNomeRelatorioExportacao,
      dataFormatOptions: historicoDataFormatOptions,
      exibirBotaoVoltar: false,
      dataHistory: [...this.state.dataHistory, historicoPrimeiroNivel],
      estadoTabelaHistory: [...this.state.estadoTabelaHistory, historicoEstadoTabelaPrimeiroNivel],
      nomeRelatorioHistory: [...this.state.nomeRelatorioHistory, historicoNomeRelatorio],
      // estadoTabela: historicoEstadoTabela,
      estadoTabela: estadoTabelaAtual,
      nivel: 1,
    });
  }

  verificarSeListaConsultaPreenchida = (limpar) => {
    if (limpar) {
      this.setState({
        listaResultadosFormatados: [],
        nomeRelatorio: '',
      });
    }
  }
  render() {
    const options = {
      noDataText: 'Nenhum resultado a ser exibido.',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroSimulacaoCompensacao
            // handleSearchFilter={this.realizaConsulta}
            handleSearchFilter={this.preparaNovaConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            list={this.state.listaRegistrosIndexada}
            listaRegistrosIndexadaAtualizada={this.state.listaRegistrosIndexadaAtualizada}
            destinatarios={this.props.destinatarios}
            estadosSimulacaoCompensacao={this.props.estadosSimulacaoCompensacao}
            estadosSimulacaoCompensacaoObservador={this.state.estadosSimulacaoCompensacaoObservador}
            papelUsuarioLogado={this.state.papelUsuarioLogado}
            recuperarCnpjParticipanteComoObservador={this.recuperarCnpjParticipanteComoObservador}
            verificarSeListaConsultaPreenchida={this.verificarSeListaConsultaPreenchida}
          />
          {this.state.nomeRelatorio !== '' &&
            <SimulacaoCompensacao
              legend={this.state.nomeRelatorio}
              legendExportacao={this.state.nomeRelatorioExportacao}
              bordered
              headers={this.state.colunasRetorno}
              data={this.state.listaResultadosFormatados}
              options={options}
              pagination
              remote
              dataFormatOptions={this.state.dataFormatOptions}
              landscape
              containerStyle={this.defineContainerStyle()}
              fetchInfo={fetchInfo}
              rowAtual={this.state.rowAtual}
              urlExportacao={this.state.urlExportacao}
              parametrosExportacao={this.state.parametrosExportacao}
              voltarAction={this.handleVoltar}
              exibirBotaoVoltar={this.state.exibirBotaoVoltar}
            />
          }
        </DtpContentContainer>
      )
    );
  }
}

ConsultaSimulacaoCompensacao.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  estadosSimulacaoCompensacao: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

ConsultaSimulacaoCompensacao.defaultProps = {
  destinatarios: [],
  estadosSimulacaoCompensacao: [],
};

const mapStateToProps = state => ({
  destinatarios: state.base.destinatarios,
  complementoTitulo: state.base.complementoTitulo,
  estadosSimulacaoCompensacao: state.base.estadosSimulacaoCompensacao,
});

export default connect(mapStateToProps)(ConsultaSimulacaoCompensacao);




// WEBPACK FOOTER //
// ./src/pages/relatorios/ConsultaSimulacaoCompensacao.jsx